import PropTypes from "prop-types";
import React from "react";
import ProductGridList from "./ProductGrid/ProductgridList";

const ShopProducts = ({
  products,
  layout,
  addToCart,
  currency,
  cartItems,
  wishlistItems,
  compareItems,
  setIsQRScannerOpen,
  setSelectedProduct,
}) => (
  <div className="shop-bottom-area mt-35">
    <div className={`row ${layout || ""}`}>
      <ProductGridList
        products={products}
        spaceBottomClass="mb-25"
        addToCart={addToCart}
        currency={currency}
        cartItems={cartItems}
        wishlistItems={wishlistItems}
        compareItems={compareItems}
        setIsQRScannerOpen={setIsQRScannerOpen}
        setSelectedProduct={setSelectedProduct}
      />
    </div>
  </div>
);

ShopProducts.propTypes = {
  layout: PropTypes.string,
  products: PropTypes.array,
  addToCart: PropTypes.func,
  currency: PropTypes.object,
  cartItems: PropTypes.object,
  wishlistItems: PropTypes.array,
};

export default ShopProducts;
